import React from 'react';
import PropTypes from 'prop-types';
import { colors } from '../../../src/theme/color-palette.js';
import styles from './CustomTableCell.module.css';

function CustomTableCell(props) {
	const customColorFormatter = (cell) => {
		let style = {};

		style.borderRadius = '4px';
		style.padding = '0px 8px 0px 8px';
		style.width = '-webkit-fill-available';
		style.textAlign = props?.colDef?.type === 'leftAligned' ? 'left' : 'right';
		style.height = '48px';
		style.display = 'block';

		if (parseFloat(cell?.value) < 0) {
			style.background = colors.ERROR_LIGHT_HIGHLIGHT;
			style.color = colors.ERROR_MD;
		}

		return style;
	};

	return (
		<div className={styles.insightsCustomCell}>
			<div style={customColorFormatter(props)}>{props.valueFormatted}</div>
		</div>
	);
}

CustomTableCell.propTypes = {
	valueFormatted: PropTypes.any,
	colDef: PropTypes.any,
};

export default CustomTableCell;
